import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styles: []
})
export class PdfViewerComponent implements OnInit {

    @Input() pdfURI: any = null;
    // @Input() pdfBase64: any = null;
    // @Input() download: any = true;
    @Input() title: string = null;
    @Output() closeEvent = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
    }

    close() {
        this.closeEvent.emit();
    }

    fullscreen() {

    }

}
